const src = import.meta.ROLLUP_FILE_URL_fN3GBDImFL4syCUWbqabiA;
export default {
  src,
  srcSet: src + " " + 648 + "w",
  width: 648,
  height: 960,
};